<template>
  <div class="all_body">
    <!-- banner -->
    <div class="manager_banner">
      <el-carousel>
        <el-carousel-item v-for="(items,index) in banner_list" :key="index">
          <img :src="items.img" class="banner-img" @click="managerInfo(items.url)" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- manager_nav -->
    <div class="manager_nav">
      <div class="manager_jinji" @click="goNav(1)">
        <img :src="jinji" alt />
      </div>
      <div class="manager_jinji" @click="goNav(2)">
        <img :src="yangzhi" alt />
      </div>
      <div class="manager_jinji" @click="goNav(3)">
        <img :src="jinpai" alt />
      </div>
    </div>

    <!-- 金牌名师 -->
    <div class="manager_jin" id="nav3">
      <div class="manager_jin_title">
        <div class="manager_jin_title_line"></div>金牌名师
      </div>
      <div class="manager_jin_middle">
        <div class="manager_jin_middle_1" v-for="(item,index) in teacher_list.slice(0,8)" :key="index">
          <div class="manager_jin_middle_li">
            <img :src="item.cover" />
          </div>
          <div class="manager_jin_middle_name">{{item.teach_name}}</div>
          <div class="manager_jin_middle_des">{{item.descript}}</div>
        </div>
      </div>
    </div>

    <!-- 金鸡讲堂 -->
    <div class="manager_jinjigt" id="nav1">
      <div class="manager_jinji_left">
        <img :src="jiangtang" alt />
      </div>
      <div class="manager_jinji_right">
        <div class="manager_right_content" v-for="(items,index) in jinji_list.slice(0,6)" :key="index">
          <div class="manager_right_content_img" @click="getVideoDetail(items.id)">
            <img :src="items.cover" />
          </div>
          <div class="manager_right_content_title">{{items.title}}</div>
          <div class="manager_right_content_bottom">
            <img :src="play" class="play" />
            <div >{{items.view}}</div>
            <img :src="icon" class="icon" />
            <div >38</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 养殖课堂 -->
    <div class="manager_jinjigt manager_bottom" id="nav2">
      <div class="manager_jinji_left">
        <img :src="ketang" alt />
      </div>
      <div class="manager_jinji_right">
        <div class="manager_right_content" v-for="(items,index) in yangzhi_list.slice(0,6)" :key="index">
          <div class="manager_right_content_img" @click="getVideoDetail(items.id)">
            <img :src="items.cover" />
          </div>
          <div class="manager_right_content_title">{{items.title}}</div>
          <div class="manager_right_content_bottom">
            <img :src="play" class="play" />
            <div >{{items.view}}</div>
            <img :src="icon" class="icon" />
            <div >38</div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { videoBanner, videoTeacherList, videoBreedList } from "../api/api";

export default {
  name: "Manager",
  data() {
    return {
      jinji: "./static/img/jinji.png",
      yangzhi: "./static/img/yangzhi.png",
      jinpai: "./static/img/jinpai.png",
      play: "./static/img/play.png",
      icon: "./static/img/icon.png",
      jiangtang: "./static/img/jiangtang.png",
      ketang: "./static/img/ketang.png",
      banner_list: [],
      teacher_list: [],
      jinji_list: [],
      yangzhi_list: []
    };
  },
  mounted() {
    this.$store.commit("settab", 3);

    videoBanner().then(rs => {
      //console.log(rs);
      for (var i = 0; i < rs.data.length; i++) {
        //判断获取的url是否有"http"标注 如果有就导航到新闻界面,如果没有证明跳转的是鸡蛋哥视频使用路由跳转
        if (rs.data[i].url.indexOf("http") > -1) {
          this.banner_list.push({
            url: "",
            img: rs.data[i].cover
          });
        } else {
          this.banner_list.push({
            url: "",
            img: rs.data[i].cover
          });
        }
      }
    });
    videoTeacherList().then(res => {
      this.teacher_list = res.data;
    });
    videoBreedList({
      type: 1,
      page: 1,
      ticket: this.$store.state.ticket
    }).then(res => {
      this.jinji_list = res.data;
    });
    videoBreedList({
      type: 0,
      page: 1,
      ticket: this.$store.state.ticket
    }).then(res => {
      this.yangzhi_list = res.data;
    });
  },

  methods: {
    managerInfo(url) {
      console.log(url);
    },
    goNav(key) {
      // 获取点击的按钮对应页面的id
      var PageId = document.querySelector("#nav" + key);
      // 打印出对应页面与窗口的距离
      console.log(PageId.offsetTop);
      // 使用平滑属性，滑动到上方获取的距离
      // 下方我只设置了top，当然 你也可以加上 left 让他横向滑动
      // widow 根据浏览器滚动条，如果你是要在某个盒子里面产生滑动，记得修改
      window.scrollTo({
        top: PageId.offsetTop,
        behavior: "smooth"
      });
    },

    getVideoDetail(id){
      this.$router.push('/videoDetail/'+ id)
    }
  }
};
</script>

<style>
.all_body {
  width: 100%;
  padding-left: 11%;
  padding-right: 10%;
}
.manager_banner {
  margin-top: 30px;
  height: 500px;
  width: 100%;
}
.manager_banner .el-carousel__container{
  height: 500px;
}
.banner-img {
  width: 100%;
  height: 100%;
}
.manager_nav {
  display: flex;
  width: 100%;
  height: 130px;
  background: #545155;
  margin-top: 12px;
}
.manager_jinji {
  margin-left: 82px;
  cursor: pointer;
}
.manager_jinji img {
  width: 200px;
  height: 130px;
}
.manager_jin {
  margin-top: 44px;
}
.manager_jin_title {
  display: flex;
  height: 32px;
  line-height: 32px;
  font-size: 32px;
  color: #000000;
}
.manager_jin_title_line {
  width: 6px;
  height: 40px;
  background: #55b233;
  margin-right: 11px;
}
.manager_jin_middle {
  display: flex;
  width: 100%;
  margin: 0 auto;
  margin-top: 50px;
  overflow: hidden;
  /* margin-left: 30px; */
}
.manager_jin_middle_1 {
  margin-right: 92px;
  text-align: center;
  width: 104px;
}

.manager_jin_middle_li {
  width: 146px;
  height: 104px;
}
.manager_jin_middle_li img {
  width: 104px;
  height: 100%;
  border-radius: 50%;
}
.manager_jin_middle_name {
  width: 146px;
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  margin-top: 10px;
  overflow: hidden;
  white-space: nowrap;
}
.manager_jin_middle_des {
  width: 146px;
  height: 33px;
  font-size: 14px;
  color: #000000;
  margin-top: 10px;
}
.manager_jinjigt {
  display: flex;
  margin-top: 60px;
}
.manager_jinji_left {
  width: 30%;
  height: 600px;
}
.manager_jinji_left img {
  width: 100%;
  height: 100%;
}
.manager_jinji_right {
  width: 70%;
  height: 600px;
  overflow: hidden;
}
.manager_right_content {
  width: 31.44%;
  height: 310px;
  float: left;
  margin-left: 20px;
  cursor: pointer;
}
.manager_right_content_img {
  width: 100%;
  height: 210px;
  margin: 0 auto;
}
.manager_right_content_img img {
  width: 100%;
  height: 100%;
}
.manager_right_content_title {
  margin-top: 22px;
  height: 19px;
  line-height: 19px;
  font-size: 18px;
  color: #000000;
  overflow: hidden;
}
.manager_right_content_bottom {
  display: flex;
  margin-top: 20px;
  font-size: 14px;
}
.play {
  width: 19px;
  height: 19px;
  line-height: 19px;
  margin-top: 2px;
  opacity: 0.3;
  margin-right: 8px;
}
.icon {
  width: 20px;
  height: 19px;
  line-height: 19px;
  opacity: 0.2;
  margin-right: 8px;
  margin-left: 20px;
  margin-top: 3px;
}
.manager_bottom{
  margin-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Manager.vue